import { render, staticRenderFns } from "./Leaders.vue?vue&type=template&id=0511eace&scoped=true&"
import script from "./Leaders.vue?vue&type=script&lang=js&"
export * from "./Leaders.vue?vue&type=script&lang=js&"
import style0 from "./Leaders.vue?vue&type=style&index=0&id=0511eace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0511eace",
  null
  
)

export default component.exports